import { ReactNode } from 'react';

import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { ManageablePageStatusNodeFields } from '../../../../../../generated/graphql';
import { Button } from '../../../../../Clickables/Buttons/Button';

export interface IBrandLabelProps {
  navigateTo: (path: string) => void;
  page: ManageablePageStatusNodeFields;
  children: ReactNode;
}

export const BrandLabel = ({ page, children, navigateTo }: IBrandLabelProps) => {
  const { currentPage } = useAnalytics();
  if (!page.published) {
    return <div className="flex text-base">{children}</div>;
  }
  return (
    <Button
      type="button"
      variant="textPrimary"
      className="flex grow items-center"
      onClick={() => {
        navigateTo(`/pages/${page.legacyId}`);
        trackEvent({
          name: 'mykiss_hamburger_clicked',
          properties: { action: 'navigate', source: currentPage },
        });
      }}
    >
      {children}
    </Button>
  );
};
